import { render } from "./CrmPage.vue?vue&type=template&id=2b5c5622&scoped=true"
import script from "./CrmPage.vue?vue&type=script&lang=js"
export * from "./CrmPage.vue?vue&type=script&lang=js"

import "./CrmPage.vue?vue&type=style&index=0&id=2b5c5622&scoped=true&lang=css"

import exportComponent from "C:\\ExactFloMarketingTool\\exactfloMarketingTool\\frontend\\marketingtool\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5c5622"]])

export default __exports__